import axios from 'axios'
import { host } from './host'
import load from '../components/load'

const portal = axios.create({
  baseURL: host + 'index'
})

portal.interceptors.request.use(config => {
  load.loading()
  return config
})

portal.interceptors.response.use(
  (response) => {
    load.hide()
    const { data } = response
    if (data.error === true) {
      const error = new Error(data.code)
      error.__isCustomizedError = true
      throw error
    }
    return response
  },
  (error) => {
    load.error(error.__isCustomizedError ? error.message : '网络错误')
    return Promise.reject(error)
  }
)

export const getPortalInfo = () => {
  return portal.get('/index.do')
}

export const getBookList = query => {
  query.searchItem = query.searchItem || ''
  query.sort = query.sort || ''
  query.currentPage = query.currentPage || 1
  return portal.post('getBook.do', query)
}

export const getBookDetail = id => {
  return portal({
    url: 'bookDetail.do',
    params: {
      bookId: id
    }
  })
}

export const getCourseList = query => {
  query.pageSize = query.pageSize || 10
  query.pageNum = query.pageNum || 1
  query.keyword = query.keyword || ''
  query.order = query.order || 1
  return portal({
    url: 'course.do',
    params: query
  })
}

export const getCourseDetail = id => {
  return portal({
    url: 'courseDetail.do',
    params: {
      courseID: id
    }
  })
}

const ALL_ID = -1
const bookFilterLabels = ['图书分类', '版本来源', '荣誉属性', '教学层次', '专业类别', '出版时间']
const courseFilterLabels = ['课程分类', '课程层次', '荣誉属性', '专业类别']
const yearCondition = {
  label: '出版时间',
  name: 'year',
  categories: [
    {
      name: '全部',
      id: -1
    },
    {
      name: '2019年',
      id: '2019'
    },
    {
      name: '2018年',
      id: '2018'
    },
    {
      name: '2017年',
      id: '2017'
    },
    {
      name: '2016年',
      id: '2016'
    },
    {
      name: '2015年',
      id: '2015'
    },
    {
      name: '更早年份',
      id: '2015-before'
    }
  ]
}

export const getConditions = async type => {
  const res = await portal({
    url: 'getSearchCondition.do?type=' + type
  })
  const conditions = res.data.body
  const list = []
  let labels = []
  if (type === 1) {
    labels = bookFilterLabels
  } else if (type === 2) {
    labels = courseFilterLabels
  }
  const conditionsKeys = Object.keys(conditions)
  conditionsKeys.forEach(key => {
    const value = conditions[key]
    value.forEach(item => {
      const index = item.type - 1
      const category = list[index] || (list[index] = {})
      category.name = key
      category.label = labels[index]
      category.categories || (category.categories = [{ id: ALL_ID, name: '全部' }])
      category.categories.push({
        id: item.id,
        name: item.title
      })
    })
  })

  if (type === 1) {
    list.push(yearCondition)
  }
  res.data.body = list
  return res
}
